var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetTheAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245,
    height: 197.809,
    viewBox: "0 0 245 197.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-231.222 -124.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M714.3,124.767H640.759a15.634,15.634,0,0,0-15.252,12.2L588.348,301.787a12.635,12.635,0,0,0,11.7,15.4l75.6,3.725a16.693,16.693,0,0,0,17.247-13.7l21.08-116.532,1.568.448,4.034-22.087-1.614-.4,5.884-32.529a9.626,9.626,0,0,0-9.551-11.339Z",
    transform: "translate(-247.788 0.231)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M667.338,136.4h-8.584a10.8,10.8,0,0,0-10.556,8.5L612.53,308.375a6.694,6.694,0,0,0,6.1,8.107l75.357,4.939a8.67,8.67,0,0,0,9.1-7.115l30.436-168.972a7.594,7.594,0,0,0-7.474-8.94H717.91a3.584,3.584,0,0,0-3.461,2.652h0a3.164,3.164,0,0,1-3.056,2.342h-38.66a5.41,5.41,0,0,1-5.394-4.993Z",
    transform: "translate(-264.687 -7.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M748.178,296.558a.611.611,0,0,0,.622-.5l16.665-91.974a.618.618,0,0,0-.128-.5.6.6,0,0,0-.458-.223l-75.818-.9h-.007a.608.608,0,0,0-.588.477L668.82,291.933a.618.618,0,0,0,.109.5.6.6,0,0,0,.45.24Z",
    transform: "translate(-303.869 -53.721)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M710.922,529.535a.306.306,0,0,0-.3.236l-.71,3.043a.306.306,0,0,0,.275.374l40.11,2.851a.308.308,0,0,0,.322-.247l.683-3.521a.306.306,0,0,0-.282-.363l-40.082-2.373Z",
    transform: "translate(-332.408 -280.751)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M755.584,570.267a.306.306,0,0,0,.321-.232l.869-3.528a.306.306,0,0,0-.275-.378l-51.223-3.582a.3.3,0,0,0-.315.218l-.9,3.049a.306.306,0,0,0,.268.391Z",
    transform: "translate(-328.339 -303.676)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M746.584,607.267a.306.306,0,0,0,.321-.232l.869-3.528a.306.306,0,0,0-.275-.378l-51.223-3.582a.3.3,0,0,0-.315.218l-.9,3.049a.306.306,0,0,0,.268.391Z",
    transform: "translate(-322.09 -329.367)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M271.562,739.329c0,2.558-23.414,2.83-52.231,4.631-28.792,1.8-52.231-2.073-52.231-4.631s23.549-7.7,52.231-4.631C248.148,737.785,271.562,736.771,271.562,739.329Z",
    transform: "translate(64.123 -421.616)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M715.006,664.186a.3.3,0,0,0,.325-.231l1.838-7.351a.306.306,0,0,0-.271-.379l-31.456-2.646a.311.311,0,0,0-.324.238l-1.568,7.055a.306.306,0,0,0,.27.371Z",
    transform: "translate(-314.102 -366.954)",
    fill: "#356ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M303.308,494.562a3.284,3.284,0,0,0,.484-5.013l1.274-28.43-6.484.728.377,27.809a3.3,3.3,0,0,0,4.351,4.9Z",
    transform: "translate(-29.415 -227.284)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M69.534,542.627l3.691.649,3.648-13.926-4.836-.958Z",
    transform: "translate(216.188 -227.223)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M0,0H11.777V4.55H4.55A4.55,4.55,0,0,1,0,0Z",
    transform: "translate(295.928 320.73) rotate(-170.029)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M36.391,548.175h3.747l1.783-14.453H36.39Z",
    transform: "translate(239.202 -230.924)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M0,0H11.777V4.55H4.55A4.55,4.55,0,0,1,0,0H0Z",
    transform: "translate(286.566 320.731) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M334.485,606.322a1.419,1.419,0,0,1-.175-.01l-4.41-.363a1.492,1.492,0,0,1-1.3-1.73l4.378-21.6-2.751-14.51a.5.5,0,0,0-.984.049l-4.053,36.869a1.5,1.5,0,0,1-1.592,1.356l-4.155-.155a1.494,1.494,0,0,1-1.386-1.416l.332-44.553,21.542-2.693,1.505,23.242-.006.025-5.5,24.352a1.493,1.493,0,0,1-1.448,1.14Z",
    transform: "translate(-43.259 -294.252)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 7.507,
    cy: 7.507,
    r: 7.507,
    transform: "translate(274.729 200.399)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M322,461.26a6.146,6.146,0,0,1-3.318-.949c-3.637-2.273-7.767-1.37-9.9-.629a1.492,1.492,0,0,1-1.29-.147,1.47,1.47,0,0,1-.68-1.086l-3.888-34.729a12.169,12.169,0,0,1,8.334-13.008h0q.309-.1.628-.183a12.094,12.094,0,0,1,10.078,1.749,12.287,12.287,0,0,1,5.247,8.972l3.274,34.962a1.469,1.469,0,0,1-.467,1.225C328.87,458.5,325.539,461.259,322,461.26Z",
    transform: "translate(-32.695 -191.864)",
    fill: "#4186e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M303.325,442.742l-8.772-.965a1.747,1.747,0,0,1-1.5-2.18l2.233-8.511a4.853,4.853,0,1,1,9.645,1.089l.331,8.764a1.748,1.748,0,0,1-1.937,1.8Z",
    transform: "translate(-25.857 -203.439)",
    fill: "#4186e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M373.528,490.654a3.284,3.284,0,0,0-.124-5.033l-2.162-28.377-6.354,1.43,3.729,27.635a3.3,3.3,0,0,0,4.91,4.345Z",
    transform: "translate(-75.775 -224.594)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M355.654,437.947a1.746,1.746,0,0,1-.556-1.345l.332-8.764a4.853,4.853,0,1,1,9.645-1.089l2.233,8.511a1.747,1.747,0,0,1-1.5,2.18l-8.772.965a1.746,1.746,0,0,1-1.382-.458Z",
    transform: "translate(-68.976 -200.427)",
    fill: "#4186e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M320.631,361.378a1.737,1.737,0,0,1-.4-.046l-.038-.009c-6.6-1.009-8.059-4.833-8.379-6.429-.331-1.653.046-3.248.9-3.868a4.759,4.759,0,0,1,.222-3.87,6.269,6.269,0,0,1,3.7-2.648,4.582,4.582,0,0,1,4.47-.269c3.582-1.325,4.951-.222,5.2.024,1.6.288,2.577.906,2.9,1.839.609,1.752-1.316,3.931-1.4,4.023l-.043.048-2.867.137a1.943,1.943,0,0,0-1.828,2.236h0a9.052,9.052,0,0,0,.293,1.025c.489,1.53.856,2.837.383,3.334a.767.767,0,0,1-.8.139c-.448-.12-.753-.095-.9.075-.235.263-.164.928.2,1.872a1.754,1.754,0,0,1-.32,1.787,1.7,1.7,0,0,1-1.292.6Z",
    transform: "translate(-38.842 -145.682)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTheAppIcon);
export default __webpack_public_path__ + "static/media/getTheAppIcon.a846aca3ca41af33c2341d289fc279ea.svg";
export { ForwardRef as ReactComponent };